import { useCallback } from 'react';

import { useState } from 'react';

interface AlertState {
  open: boolean;
  message: string;
  severity: 'error' | 'success';
}

export const useAlert = () => {
  const [alert, setAlert] = useState<AlertState>({
    open: false,
    message: '',
    severity: 'success',
  });

  const showAlert = useCallback(
    (message: string, severity: AlertState['severity']) => {
      setAlert({
        open: true,
        message,
        severity,
      });
    },
    []
  );

  return { alert, setAlert, showAlert };
};
